import React from 'react'
import PropTypes from 'prop-types'

const UserShield = ({ shield, openProfile, title }) => (
  <React.Fragment>
    {shield ? (
      <div className="shield--canvas__texture">
        <div title={title} onClick={() => (openProfile ? openProfile() : null)} className="shield">
          <div className="shield--item"></div>
          <div className={`shield--icon shield--${shield.emblemColor}`}>
            <span className={`icon-emblem-${shield.emblemGeometry}`}></span>
          </div>
          <div className={`shield--background shield--${shield.bannerColor}`}>
            <span className={`icon-shield-${shield.bannerGeometry}`}></span>
          </div>
        </div>
      </div>
    ) : null}
  </React.Fragment>
)

UserShield.propTypes = {
  shield: PropTypes.object,
  openProfile: PropTypes.func,
}

export default UserShield
